export const UNITS = {
  METERS_TO_MILES: 0.000621371,
  METERS_TO_KILOMETERS: 0.001,
  MILES_TO_METERS: 1609.34,
  KILOMETERS_TO_METERS: 1000,
  MILES_TO_KILOMETERS: 1.60934,
  KILOMETERS_TO_MILES: 0.621371,
  METERS_TO_YARDS: 1.09361,
  YARDS_TO_METERS: 0.9144,
}
